import React, { Component } from 'react';
import './kanban.css'
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ProjectSelect from '../Projects/ProjectSelect'
import GroupSelectBlock from '../Projects/GroupSelectBlock'
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import authStore from '../../Auth/AuthStore';
import MainStore from '../../../MainStore';
import { HubConnectionBuilder } from '@aspnet/signalr';
import WorkStore from '../Kanban/WorkStore'
import { DragDropContext } from 'react-beautiful-dnd'
import UserSelect from '../Users/UserSelect';
import AddIcon from '@mui/icons-material/AddCircleOutline';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import ProjectChipBlock from '../Kanban/ProjectChipBlock';
import FilterBottomPanel from './FilterBottomPanel';
import { observer } from 'mobx-react';
import Popover from '@mui/material/Popover';
import KanbanColumn from './KanbanColumn';
import ProjectTimeMenu from '../Projects/ProjectTimeMenu';
import { fetchWithAuth } from '../../Auth/GlobalFetchWithAuth';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import FaceIcon from '@mui/icons-material/Face';
import SvgIcon from '@mui/material/SvgIcon';
import AccountSelect from './AccountSelect';
import PrioritySelectBlock from './Controls/PrioritySelectBlock';
import Snowfall from 'react-snowfall';
var Snow = require('react-snow-effect');
const snowflakeImg1 = require('../../../images/sf1.png')
const snowflakeImg2 = require('../../../images/sf2.png')

const snowflake1 = document.createElement('img')
snowflake1.src = snowflakeImg1;
const snowflake2 = document.createElement('img')
snowflake2.src = snowflakeImg2

const images = [snowflake1, snowflake2]

/*
 * The Kanban React component
 */
export default class Kanban extends Component {
    render() {
        return (
            <div className="work-kanban ">
                
                <KanbanBoard />
            </div>
        );
    }
}

/*
 * The Kanban Board React component
 */
const KanbanBoard = observer(class KanbanBoard extends Component {
    constructor(props) {
        super(props);

        this.allColumns = [
            { name: 'CR', id: '11111111-a870-4dc1-ab2b-e2cbe7f9b6dc', isShow: false, isCollapsable: true },
            { name: 'Готово к анализу', id: 'e3e8b238-a870-4dc1-ab2b-e2cbe7f9b6dc', isShow: true, isCollapsable: true },
            //{ name: 'Готово к анализу', id: '6bbdce65-36fa-45db-95c5-ad70a5d28bba', isShow: false },
            { name: 'Анализ', id: 'c949fc78-a8e6-48b0-b8cc-a75a7e6c4893', isShow: true, isCollapsable: true },
            //{ name: 'Разработка документации', id: 'd06ea57c-66d0-4668-a956-f6b56a351529', isShow: true },
            //{ name: 'Оценка', id: 'b7cdea9e-1ecc-46c9-adf3-9cfa5c35d8b6', isShow: false },
            //{ name: 'Согласование', id: '276f70cb-9c48-45ce-8bb1-edc609a4277f', isShow: false },
            //{ name: 'Готово к детализации', id: '64a3e593-b86d-450d-aac4-e6b151e19925', isShow: false },
            { name: 'Детализация/Оценка', id: 'ada7d681-ee8f-4fe2-bb4a-02a0a8d7149c', isShow: false, isCollapsable: true },
            { name: 'Готово к разработке', id: 'b555b916-8367-46f5-8200-594c2fdf7443', isShow: true, isCollapsable: true },
            { name: 'Разработка', id: 'cc2e91c6-964c-44f2-845c-efdcf60f9bb1', isShow: true, isCollapsable: true },
            { name: 'Code Review', id: '1c5e93c6-964c-44f2-845c-efdcf60fffff', isShow: true, isCollapsable: true },
            { name: 'Готово к тестированию', id: '5981de5b-476d-4d18-abb7-d14201eba1a6', isShow: true, isCollapsable: true },
            { name: 'Тестирование', id: '317701e4-9088-4ee6-9f12-90280a4f5cca', isShow: true, isCollapsable: true },
            { name: 'Готово к переносу', id: [{ caption: 'Test', value: 'fe399725-6426-4349-a457-853d3f1b99a1' }, { caption: 'Pre-prod', value: 'fe399725-6426-4349-a457-853d3f1b99ae' }, { caption: 'Prod', value: '64a3e593-b86d-450d-aac4-e6b151e19925' }], isShow: true, isGroupable: true, isMultiply: true, isCollapsable: true },
            { name: 'Тестирует заказчик', id: '26dc59d4-a3e9-4cae-a991-ee420a3866ad', isShow: true, isGroupable: false, isCollapsable: true },
            { name: 'Актуализация док-ии', id: '338315f0-f3cf-4e83-b11a-fe94392b88d4', isShow: true, isCollapsable: true },
            { name: 'Done', id: '413d852e-d294-418b-b2ed-038a2d169180', isShow: true, isCollapsable: true }
        ];

        this.developerDefaultColumns = [
            { name: 'CR', id: '11111111-a870-4dc1-ab2b-e2cbe7f9b6dc', isShow: false, isCollapsable: true },
            { name: 'Готово к анализу', id: 'e3e8b238-a870-4dc1-ab2b-e2cbe7f9b6dc', isShow: false, isCollapsable: true },
            //{ name: 'Готово к анализу', id: '6bbdce65-36fa-45db-95c5-ad70a5d28bba', isShow: false },
            { name: 'Анализ', id: 'c949fc78-a8e6-48b0-b8cc-a75a7e6c4893', isShow: false, isCollapsable: true },
            //{ name: 'Разработка документации', id: 'd06ea57c-66d0-4668-a956-f6b56a351529', isShow: false },
            //{ name: 'Оценка', id: 'b7cdea9e-1ecc-46c9-adf3-9cfa5c35d8b6', isShow: false },
            //{ name: 'Согласование', id: '276f70cb-9c48-45ce-8bb1-edc609a4277f', isShow: false },
            //{ name: 'Готово к детализации', id: '64a3e593-b86d-450d-aac4-e6b151e19925', isShow: false },
            { name: 'Детализация/Оценка', id: 'ada7d681-ee8f-4fe2-bb4a-02a0a8d7149c', isShow: false, isCollapsable: true },
            { name: 'Готово к разработке', id: 'b555b916-8367-46f5-8200-594c2fdf7443', isShow: true, isCollapsable: true },
            { name: 'Разработка', id: 'cc2e91c6-964c-44f2-845c-efdcf60f9bb1', isShow: true, isCollapsable: true },
            { name: 'Code Review', id: '1c5e93c6-964c-44f2-845c-efdcf60fffff', isShow: true, isCollapsable: true },
            { name: 'Готово к тестированию', id: '5981de5b-476d-4d18-abb7-d14201eba1a6', isShow: true, isCollapsable: true },
            { name: 'Тестирование', id: '317701e4-9088-4ee6-9f12-90280a4f5cca', isShow: true, isCollapsable: true },
            { name: 'Готово к переносу', id: [{ caption: 'Test', value: 'fe399725-6426-4349-a457-853d3f1b99a1' }, { caption: 'Pre-prod', value: 'fe399725-6426-4349-a457-853d3f1b99ae' }, { caption: 'Prod', value: '64a3e593-b86d-450d-aac4-e6b151e19925' }], isShow: false, isGroupable: true, isMultiply: true, isCollapsable: true },
            { name: 'Тестирует заказчик', id: '26dc59d4-a3e9-4cae-a991-ee420a3866ad', isShow: false, isGroupable: false, isCollapsable: true },
            { name: 'Актуализация док-ии', id: '338315f0-f3cf-4e83-b11a-fe94392b88d4', isShow: false, isCollapsable: true},
            { name: 'Done', id: '413d852e-d294-418b-b2ed-038a2d169180', isShow: true, isCollapsable: true}
        ];

        this.salesDefaultColumns = [
            { name: 'Backlog', id: 'e3e8b238-a870-4dc1-ab2b-e2cbe7f9b6dc', isShow: true, isCollapsable: true },
            { name: 'Готово к проработке', id: '338315f0-f3cf-4e83-b11a-fe94392b88d4', isShow: true, isCollapsable: true },
            { name: 'Подготовка решения', id: '4bf90992-9332-473a-92e9-91bf6e0c3d3f', isShow: true, isCollapsable: true },
            { name: 'Готово к обсуждению с клиентом', id: 'b555b916-8367-46f5-8200-594c2fdf7443', isShow: true, isCollapsable: true },
            { name: 'Проработка с клиентом', id: 'cc2e91c6-964c-44f2-845c-efdcf60f9bb1', isShow: true, isCollapsable: true },
            //{ name: 'Ретроспектива', id: '5981de5b-476d-4d18-abb7-d14201eba1a6', isShow: true },
            { name: 'Done', id: '413d852e-d294-418b-b2ed-038a2d169180', isShow: true, isCollapsable: true }
        ];

        var availableColumns = this.getAvailbaleColumns();

        this.state = ({
            works: [],
            draggedOverCol: 0,
            isWorkDialogOpen: false,
            dragSrcPosition: 0,
            work: {
            },
            selectedTab: 0,
            isColumnMenuOpen: false,
            searchStr: '',
            searchType: 0,
            isOnlyMy: localStorage.getItem('filter_isOnlyMy') === 'true',
            isPortal: localStorage.getItem('filter_isPortal') === 'true',
            isSnow: localStorage.getItem('filter_isSnow') === 'true',
            isNewYear: localStorage.getItem('filter_isNewYear') === 'true',
            isShowAll: localStorage.getItem('filter_isShowAll') === 'true',
            isOnlyMyProjects: localStorage.getItem('filter_isOnlyMyProjects') === 'true',
            filterProjectId: (localStorage.getItem('filterProjectId') !== 'null' && !!localStorage.getItem('filterProjectId')) ? localStorage.getItem('filterProjectId') : '',
            filterGroupId: (localStorage.getItem('filterGroupId') !== 'null' && !!localStorage.getItem('filterGroupId')) ? localStorage.getItem('filterGroupId') : '',
            filterPriorityId: (localStorage.getItem('filterPriorityId') !== 'null' && !!localStorage.getItem('filterPriorityId')) ? localStorage.getItem('filterPriorityId') : '',
            filterProjectName: (localStorage.getItem('filterProjectName') !== 'null') ? localStorage.getItem('filterProjectName') : '',
            filterGroupName: (localStorage.getItem('filterGroupName') !== 'null' && !!localStorage.getItem('filterGroupName')) ? localStorage.getItem('filterGroupName') : '',
            filterAssigneId: (localStorage.getItem('filterAssigneId') !== 'null' && !!localStorage.getItem('filterAssigneId')) ? localStorage.getItem('filterAssigneId') : '',
            filterAssigneeName: (localStorage.getItem('filterAssigneeName') !== 'null' && !!localStorage.getItem('filterAssigneeName')) ? localStorage.getItem('filterAssigneeName') : '',
            filterPriorityName: (localStorage.getItem('filterPriorityName') !== 'null' && !!localStorage.getItem('filterPriorityName')) ? localStorage.getItem('filterPriorityName') : '',
            filterAccountId: (localStorage.getItem('filterAccountId') !== 'null' && !!localStorage.getItem('filterAccountId')) ? localStorage.getItem('filterAccountId') : '',
            filterAccountName: (localStorage.getItem('filterAccountName') !== 'null' && !!localStorage.getItem('filterAccountName')) ? localStorage.getItem('filterAccountName') : '',
            columns: availableColumns
        });

        this.handleOnDragEnd = this.handleOnDragEnd.bind(this);
        this.handleCardOpen = this.handleCardOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleCardAdd = this.handleCardAdd.bind(this);
        this.handleCardDeveloperAdd = this.handleCardDeveloperAdd.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.startSearch = this.startSearch.bind(this);
        this.handleQuickFilterMyChange = this.handleQuickFilterMyChange.bind(this);
        this.handleQuickFilterMyProjectChange = this.handleQuickFilterMyProjectChange.bind(this);
        this.handleQuickFilterProjectChange = this.handleQuickFilterProjectChange.bind(this);
        this.handleQuickFilterGroupChange = this.handleQuickFilterGroupChange.bind(this);
        this.handleQuickFilterPriorityChange = this.handleQuickFilterPriorityChange.bind(this);
        this.handleQuickFilterAccountChange = this.handleQuickFilterAccountChange.bind(this);
        this.handleQuickFilterProjectsChange = this.handleQuickFilterProjectsChange.bind(this);
        this.handleCtrlCardClick = this.handleCtrlCardClick.bind(this);
        this.handleWorkFlagUpdate = this.handleWorkFlagUpdate.bind(this);
        this.handleQuickFilterAssigneChange = this.handleQuickFilterAssigneChange.bind(this);
        this.handleQuickFilterIsDoneVisibleChange = this.handleQuickFilterIsDoneVisibleChange.bind(this);
        this.handleQuickFilterIsShowAllChange = this.handleQuickFilterIsShowAllChange.bind(this);
        this.handleQuickFilterIsPortalOnChange = this.handleQuickFilterIsPortalOnChange.bind(this);
        this.handleQuickFilterSnowOnChange = this.handleQuickFilterSnowOnChange.bind(this);
        this.handleQuickFilterisNewYearOnChange = this.handleQuickFilterisNewYearOnChange.bind(this);
        this.checkWork = this.checkWork.bind(this);
        this.handleColumnMenuClick = this.handleColumnMenuClick.bind(this);
        this.handleColumnMenuClose = this.handleColumnMenuClose.bind(this);
        this.handleColumnShowChange = this.handleColumnShowChange.bind(this);
        this.handleSalesFilterChange = this.handleSalesFilterChange.bind(this);
        this.getAvailbaleColumns = this.getAvailbaleColumns.bind(this);
        this.load = this.load.bind(this);
        this.handleSpeedDialOpen = this.handleSpeedDialOpen.bind(this);
        this.handleSpeedDialClose = this.handleSpeedDialClose.bind(this);

        MainStore.setAutorunFunction(() => { this.startSearch(); });
        MainStore.setSalesFilterChangeFunction(() => { this.handleSalesFilterChange(); });

        const hubConnection = new HubConnectionBuilder()
            .withUrl("/hub")
            .build();

        hubConnection.on('workAdded', (senderId, work) => {
            if (senderId !== authStore.getUserId) {
                this.checkWork(work);
                //WorkStore.updateWork(work);
                /*var works = WorkStore.getWorks.slice(0);
                works.push(work);
                works = works.sort(this.sort)
                WorkStore.setWorks(works);*/
            }
        });

        hubConnection.on('workDeleted', (workId) => {
            var works = WorkStore.getWorks.slice(0);
            var index = works.findIndex(w => w.id === workId);
            works.splice(index, 1);
            works = works.sort(this.sort)
            WorkStore.setWorks(works);
        });

        hubConnection.on('workUpdated', (senderId, work) => {
            if (senderId !== authStore.getUserId) {
                this.checkWork(work);
                /*var works = scope.state.works;

                var index = works.findIndex(w => w.id === work.id);
                works[index] = work;

                works = works.sort(this.sort);
                scope.setState({ works: works });*/
            }
        });

        hubConnection.on('schedulleUpdated', (work) => {
            var works = WorkStore.getWorks.slice(0);

            var index = works.findIndex(w => w.id === work.workId);

            if (index > -1) {
                works[index].factTotal = work.total;
                WorkStore.setWorks(works);
            }
        });

        hubConnection.onclose((error) => { console.log('socket error'); console.log(error); hubConnection.start(); });

        hubConnection.start();

        if (this.state.isSnow)
            this.addLibrary('https://uguide.ru/js/script/snowcursor.min.js');
    }

    getAvailbaleColumns() {
        var availableColumns = [];
        var availableColumnsFromCache = localStorage.getItem('workAvailableColumns2');
        var availableSalesColumnsFromCache = localStorage.getItem('workSalesAvailableColumns');
        if (MainStore.getIsFilterByNotEmptySale) {
            if (!!availableSalesColumnsFromCache) {
                availableColumns = JSON.parse(availableSalesColumnsFromCache);
            }
            else {
                availableColumns = this.salesDefaultColumns;
            }
        }
        else if (!!availableColumnsFromCache) {
            availableColumns = JSON.parse(availableColumnsFromCache);
        }
        else {
            if (authStore.getIsDeveloper) {
                availableColumns = this.developerDefaultColumns;
            }
            else {
                availableColumns = this.allColumns;
            }
        }

        return availableColumns;
    }

    componentDidMount() {
        var scope = this;
        if (!authStore.isAuth) {
            authStore.openLogin(() => { scope.load(); });
            return;
        }
        else this.load();
    }

    addLibrary(urlOfTheLibrary) {
        const script = document.createElement('script');
        script.src = urlOfTheLibrary;
        script.async = true;
        document.body.appendChild(script);
    }

    load() {
        this.startSearch();

        var token = localStorage.getItem("token");
        var url = new URL(document.location.href);
        var workNumber = url.searchParams.get("work");
        if (workNumber) {
            if (authStore.getIsPortal) document.location.href = document.location.origin + '/portal?work=' + encodeURIComponent(workNumber);
            MainStore.setMaskVisible();
            fetch('api/Work/GetByNumber?number=' + encodeURIComponent(workNumber), {
                method: 'GET',
                body: null,
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (res) {
                if (res.status === 401) {
                }
                else {
                    res.json().then((result) => {
                        MainStore.setMaskUnvisible();
                        WorkStore.openWorkDialog(result);
                    }).catch((err) => console.log(err));
                }
            });
        }
        else {
            if (authStore.getIsPortal) document.location.href = document.location.origin + '/portal';
            var workId = url.searchParams.get("workId");
            if (workId) {
                MainStore.setMaskVisible();
                fetch('api/Work/GetById?id=' + workId, {
                    method: 'GET',
                    body: null,
                    headers: {
                        'Authorization': 'Bearer ' + token
                    }
                }).then(function (res) {
                    if (res.status === 401) {
                    }
                    else {
                        res.json().then((result) => {
                            MainStore.setMaskUnvisible();
                            WorkStore.openWorkDialog(result);
                        }).catch((err) => console.log(err));
                    }
                });
            }
        }
    }

    handleSalesFilterChange() {
        var newColumns = this.getAvailbaleColumns();

        this.setState({ columns: newColumns });
    }

    /*handleWorkUpdate(result) {
        var works = WorkStore.getWorks.slice(0);

        if (!WorkStore.getWork.id) {
            works.push(result);
        }
        else {
            var index = works.findIndex(w => w.id === result.id);

            works[index] = result;
        }
        this.setState({ works: works, isWorkDialogOpen: false });
    }*/

    handleWorkFlagUpdate(result) {
        WorkStore.updateWork(result)
    }

    checkWork(work) {
        fetchWithAuth(
            'api/Work/IsWorkFitFilter',
            JSON.stringify({
                isOnlyMy: this.state.isOnlyMy,
                projectId: this.state.filterProjectId,
                //groupId: this.state.filterGroupId,
                priorityId: this.state.filterPriorityId,
                projectIds: MainStore.getFilterProjectIds,
                searchType: this.state.searchType,
                searchStr: encodeURIComponent(this.state.searchStr),
                isMyProjects: this.state.isOnlyMyProjects,
                isOnlySales: MainStore.getIsFilterByNotEmptySale,
                isOnlyApproved: MainStore.getIsFilterByOnlyApproved,
                isOnlyProduct: MainStore.getIsFilterByProduct,
                isProgrammers: MainStore.getIsFilterByProgrammersWork,
                isAnalyst: MainStore.getIsFilterByAnalystWork,
                isShowAll: this.state.isShowAll,
                emptySP: MainStore.isFilterByEmptySP,
                isOnlyGeneral: MainStore.getIsFilterByGeneralWork,
                isFlagged: MainStore.isFilterByFlagged,
                assigneeId: this.state.filterAssigneId,
                isPortal: this.state.isPortal,
                workId: work.id
            }),
            'application/json',
            (result) => {
                if (result.isFit === true) {
                    WorkStore.updateWork(work);
                }
            }
        );
    }

    startSearch(obj) {
        MainStore.setMaskVisible();

        fetchWithAuth(
            'api/Work/GlobalSearch',
            JSON.stringify({
                isOnlyMy: this.state.isOnlyMy,
                projectId: this.state.filterProjectId,
                //groupId: this.state.filterGroupId,
                priorityId: this.state.filterPriorityId,
                projectIds: MainStore.getFilterProjectIds,
                searchType: this.state.searchType,
                searchStr: encodeURIComponent(this.state.searchStr),
                isOnlySales: MainStore.getIsFilterByNotEmptySale,
                isOnlyApproved: MainStore.getIsFilterByOnlyApproved,
                isOnlyProduct: MainStore.getIsFilterByProduct,
                isProgrammers: MainStore.getIsFilterByProgrammersWork,
                isAnalyst: MainStore.getIsFilterByAnalystWork,
                isMyProjects: this.state.isOnlyMyProjects,
                isShowAll: this.state.isShowAll,
                emptySP: MainStore.isFilterByEmptySP,
                isOnlyGeneral: MainStore.getIsFilterByGeneralWork,
                isFlagged: MainStore.isFilterByFlagged,
                assigneeId: this.state.filterAssigneId,
                isPortal: this.state.isPortal,
                accountId: this.state.filterAccountId
            }),
            'application/json',
            (result) => {
                //scope.setState({ works: result });
                WorkStore.setWorks(result);
                MainStore.setMaskUnvisible();
            }
        )
    }

    handleQuickFilterMyChange(evt) {
        var isOnlyMy = evt.target.checked;
        localStorage.setItem('filter_isOnlyMy', isOnlyMy);
        this.setState({ isOnlyMy: isOnlyMy }, () => this.startSearch(null));
    }

    handleQuickFilterMyProjectChange(evt) {
        var isOnlyMyProjects = evt.target.checked;
        localStorage.setItem('filter_isOnlyMyProjects', isOnlyMyProjects);
        this.setState({ isOnlyMyProjects: isOnlyMyProjects }, () => MainStore.setFilterProjectIds([]));

    }

    handleQuickFilterIsDoneVisibleChange(evt) {
        var isDoneVisible = evt.target.checked;
        MainStore.setIsDoneVisible(isDoneVisible);
    }

    handleQuickFilterIsShowAllChange(evt) {
        var isShowAll = evt.target.checked;
        localStorage.setItem('filter_isShowAllVisible', isShowAll);
        this.setState({ isShowAll: isShowAll }, () => this.startSearch(null));
    }

    handleQuickFilterIsPortalOnChange(evt) {
        var isPortal = evt.target.checked;
        localStorage.setItem('filter_isPortal', isPortal);
        this.setState({ isPortal: isPortal }, () => this.startSearch(null));
    }

    handleQuickFilterSnowOnChange(evt) {
        var isSnow = evt.target.checked;
        localStorage.setItem('filter_isSnow', isSnow);
        this.setState({ isSnow: isSnow } );
    }

    handleQuickFilterisNewYearOnChange(evt) {
        var isNewYear = evt.target.checked;
        localStorage.setItem('filter_isNewYear', isNewYear);
        this.setState({ isNewYear: isNewYear });
    }

    sort(a, b) {
        var res = b.priorityOrder - a.priorityOrder;
        return res !== 0 ? res : a.position - b.position;
    }

    //this is called when a Kanban card dropped over a column (called by card)
    handleOnDragEnd(e) {
        const { destination, source } = e;
        if (!destination) {
            return
        }

        if (
            destination.droppableId === source.droppableId &&
            destination.index === source.index
        ) {
            return
        }

        MainStore.setMaskVisible();
        const works = WorkStore.getWorks.slice(0);
        var work = works[works.findIndex(s => s.id === e.draggableId)];
        var newStatusId = destination.droppableId;

        if (work.assigneeRoleId === 'ebab48fb-df8d-4a1f-818e-8cf7572a2e79' && newStatusId === '413d852e-d294-418b-b2ed-038a2d169180' && !work.resultId) {
            MainStore.openSnackbar("Необходимо заполнить результат");
            MainStore.setMaskUnvisible();
            return;
        }

        //if (work.assigneeRoleId === 'ebab48fb-df8d-4a1f-818e-8cf7572a2e79' && newStatusId === '413d852e-d294-418b-b2ed-038a2d169180' && !work.description) {
        //    MainStore.openSnackbar("Необходимо заполнить результат");
        //    MainStore.setMaskUnvisible();
        //    return;
        //}

        if (newStatusId.indexOf("project") > -1) {
            newStatusId = newStatusId.substring(0, 36);
            console.log(newStatusId);
        }

        var columnWorks = works.filter(w => w.statusId === newStatusId).sort(this.sort);
        var dragSrcPosition = 0;
        if (columnWorks.length !== 0) {
            dragSrcPosition = columnWorks[e.destination.index >= columnWorks.length ? columnWorks.length - 1 : e.destination.index].position;
        }

        var selectedWorks = works.filter(w => w.isSelected).sort(this.sort);
        if (selectedWorks.length === 0) selectedWorks = [work];

        if (work.position < dragSrcPosition) dragSrcPosition = dragSrcPosition + 1;

        if (work.position !== dragSrcPosition) {
            works.forEach(w => {
                if (w.position >= dragSrcPosition && w.id !== work.id) {
                    w.position = w.position + selectedWorks.length;
                }
            })
        }
        else {
            dragSrcPosition = dragSrcPosition - 1;
            works.forEach(w => {
                if (w.position >= dragSrcPosition && w.id !== work.id) {
                    w.position = w.position + selectedWorks.length;
                }
            })
        }

        var token = localStorage.getItem("token");
        for (var i = 0; i < selectedWorks.length; i++) {
            selectedWorks[i].statusId = newStatusId;
            selectedWorks[i].position = dragSrcPosition + (selectedWorks.length - 1 - i);

            fetch('api/Work/Add', {
                method: 'POST',
                body: JSON.stringify(selectedWorks[i]),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (res) {
                if (res.status === 401) {
                    authStore.openLogin();
                    MainStore.setMaskUnvisible();
                }
                else {
                    res.json().then((result) => {
                        //var works = scope.state.works;

                        //var index = works.findIndex(w => w.id === result.id);
                        //works[index] = result;

                        //works = works.sort(this.sort);

                        MainStore.setMaskUnvisible();
                        WorkStore.updateWork(result);
                        //scope.setState({ works: works, isWorkDialogOpen: false });
                    }).catch((err) => console.log(err));
                }
            });
        }
        //works.find((w) => { return w.number === work.number; }).statusId = newStatusId;
        //this.setState({ works: works});
    }

    handleCardOpen(work) {
        WorkStore.openWorkDialog(work);
    }

    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    handleCardAdd() {
        this.setState({ "open": false }, () =>
            WorkStore.openWorkDialog({
                caption: this.state.searchStr,
                sessionId: this.uuidv4(),
                description: '',
                sp: -1,
                priorityOrder: 3,
                priorityId: '03d3011c-7afe-4c9e-aeee-9ec56323a1e1'
            })
        );        
    }

    handleCardDeveloperAdd() {
        this.setState({ "open": false });
        WorkStore.setCallback(w => {
            this.checkWork(w);
        });
        WorkStore.openWorkDialog({
            caption: this.state.searchStr,
            sessionId: this.uuidv4(),
            description: '',
            sp: -1,
            assigneeId: 'ff1c1d3b-b5b0-4604-a40a-b80cd72caac0',
            assignee: 'Антон Мочальников',
            testerId: authStore.getUserId,
            tester: authStore.getUser.fullName,
            statusId: 'b555b916-8367-46f5-8200-594c2fdf7443',
            status: 'Готово к разработке',
            priorityOrder: 3,
            priorityId: '03d3011c-7afe-4c9e-aeee-9ec56323a1e1'
        });
    }

    handleClose() {
        this.setState({ isWorkDialogOpen: false });
    }

    handleChange = name => evt => {
        this.setState({ [name]: evt.target.value });
    }

    handleRowCheckedChange = name => evt => {
        var work = this.state.work;
        work[name] = evt.target.checked;
        this.setState({ work: work });
    }

    handleQuickFilterProjectChange(project) {
        if (project) {
            localStorage.setItem('filterProjectId', project.id);
            localStorage.setItem('filterProjectName', project.name);
            this.setState({ filterProjectId: project.id, filterProjectName: project.name }, () => { this.startSearch() });
        }
        else {
            localStorage.setItem('filterProjectId', '');
            localStorage.setItem('filterProjectName', '');
            this.setState({ filterProjectId: '', filterProjectName: '' }, () => { this.startSearch() });
        }
    }

    handleQuickFilterGroupChange(group) {
        if (group) {
            localStorage.setItem('filterGroupId', group.id);
            localStorage.setItem('filterGroupName', group.name);
            this.setState({ filterGroupId: group.id, filterGroupName: group.name }, () => { this.startSearch() });
        }
        else {
            localStorage.setItem('filterGroupId', '');
            localStorage.setItem('filterGroupName', '');
            this.setState({ filterGroupId: '', filterGroupName: '' }, () => { this.startSearch() });
        }
    }

    handleQuickFilterPriorityChange(priority) {
        if (priority) {
            localStorage.setItem('filterPriorityId', priority.id);
            localStorage.setItem('filterPriorityName', priority.name);
            this.setState({ filterPriorityId: priority.id, filterPriorityName: priority.name }, () => { this.startSearch() });
        }
        else {
            localStorage.setItem('filterPriorityId', '');
            localStorage.setItem('filterPriorityName', '');
            this.setState({ filterPriorityId: '', filterPriorityName: '' }, () => { this.startSearch() });
        }
    }

    handleQuickFilterProjectsChange(projectIds) {
        this.startSearch();
        //this.setState({ filterProjectIds: projectIds }, () => {  });
    }

    handleQuickFilterAssigneChange(user) {
        if (user) {
            localStorage.setItem('filterAssigneId', user.id);
            localStorage.setItem('filterAssigneeName', user.name);
            this.setState({ filterAssigneId: user.id, filterAssigneeName: user.name }, () => { this.startSearch() });
        }
        else {
            localStorage.setItem('filterAssigneId', '');
            localStorage.setItem('filterAssigneeName', '');
            this.setState({ filterAssigneId: '', filterAssigneeName: '' }, () => { this.startSearch() });
        }
    }

    handleCtrlCardClick(workId) {
        var workIndex = WorkStore.getWorks.findIndex(w => w.id === workId);
        var works = WorkStore.getWorks.slice(0);

        if (workIndex > -1) {
            works[workIndex].isSelected = !works[workIndex].isSelected;
            WorkStore.setWorks(works);
        }
    }

    handleColumnMenuClick(event) {
        this.setState({ isColumnMenuOpen: true, menuAnchorEl: event.currentTarget });
    }

    handleColumnMenuClose() {
        this.setState({ isColumnMenuOpen: false, menuAnchorEl: null });
    }

    handleColumnShowChange = column => evt => {
        var columns = this.state.columns.slice(0);
        var index = this.state.columns.findIndex(c => c.id == column.id);
        columns[index].isShow = evt.target.checked;
        this.setState({ columns: columns });
        if (MainStore.getIsFilterByNotEmptySale) {
            localStorage.setItem("workSalesAvailableColumns", JSON.stringify(columns));
        }
        else {
            localStorage.setItem("workAvailableColumns2", JSON.stringify(columns));
        }
    }

    openProjectDrawer() {
        MainStore.setIsProjectDrawerVisible(true);
    }

    handleSpeedDialOpen(event, eventType) {
        if(eventType !== 'focus') this.setState({ "open": true });
    }

    handleSpeedDialClose() {
        this.setState({ "open": false });
    }

    handleQuickFilterAccountChange(account) {
        if (account) {
            localStorage.setItem('filterAccountId', account.id);
            localStorage.setItem('filterAccountName', account.name);
            this.setState({ filterAccountId: account.id, filterAccountName: account.name }, () => { this.startSearch() });
        }
        else {
            localStorage.setItem('filterAccountId', '');
            localStorage.setItem('filterAccountName', '');
            this.setState({ filterAccountId: '', filterAccountName: '' }, () => { this.startSearch() });
        }
    }

    render() {
        return (
            <div className={"kanban-columns-wrapper "}>
                {false && this.state.isSnow && <Snowfall
                    style={{
                        zIndex: 10000
                    }}
                    snowflakeCount={170}
                    radius={[0.5, 30.0]}
                    // Pass in the images to be used
                    images={images}
                />}


                <ProjectTimeMenu />

                <div className="quick-filter-panel clearfix">

                    {!MainStore.getIsProjectDrawerVisible && <div className="project-drawer-button-block" style={{ float: "left" }}>
                        <IconButton onClick={this.openProjectDrawer} size="large"><ChevronRightIcon /></IconButton>
                    </div>}

                    <div className="add-button-block">
                        {false && <IconButton onClick={this.handleCardAdd} size="large"><AddIcon style={{ fill: "red" }} /></IconButton>}

                        <SpeedDial
                            className="add-button-speed-dial"
                            ariaLabel="Добавить задачу"
                            icon={<SpeedDialIcon />}
                            onClose={this.handleSpeedDialClose}
                            onOpen={this.handleSpeedDialOpen}
                            open={this.state.open}
                            direction="down"
                        >
                            <SpeedDialAction
                                key="add-consultant"
                                icon={<FaceIcon />}
                                tooltipOpen
                                tooltipPlacement="right"
                                tooltipTitle="Простая задача"
                                onClick={this.handleCardAdd}
                            />
                            <SpeedDialAction
                                key="add-developer"
                                icon={<SvgIcon><svg xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><g><rect fill="none" height="24" width="24" /></g><g><g><path d="M9,15c-2.67,0-8,1.34-8,4v2h16v-2C17,16.34,11.67,15,9,15z" /><path d="M22.1,6.84c0.01-0.11,0.02-0.22,0.02-0.34c0-0.12-0.01-0.23-0.03-0.34l0.74-0.58c0.07-0.05,0.08-0.15,0.04-0.22l-0.7-1.21 c-0.04-0.08-0.14-0.1-0.21-0.08L21.1,4.42c-0.18-0.14-0.38-0.25-0.59-0.34l-0.13-0.93C20.36,3.06,20.29,3,20.2,3h-1.4 c-0.09,0-0.16,0.06-0.17,0.15L18.5,4.08c-0.21,0.09-0.41,0.21-0.59,0.34l-0.87-0.35c-0.08-0.03-0.17,0-0.21,0.08l-0.7,1.21 c-0.04,0.08-0.03,0.17,0.04,0.22l0.74,0.58c-0.02,0.11-0.03,0.23-0.03,0.34c0,0.11,0.01,0.23,0.03,0.34l-0.74,0.58 c-0.07,0.05-0.08,0.15-0.04,0.22l0.7,1.21c0.04,0.08,0.14,0.1,0.21,0.08l0.87-0.35c0.18,0.14,0.38,0.25,0.59,0.34l0.13,0.93 C18.64,9.94,18.71,10,18.8,10h1.4c0.09,0,0.16-0.06,0.17-0.15l0.13-0.93c0.21-0.09,0.41-0.21,0.59-0.34l0.87,0.35 c0.08,0.03,0.17,0,0.21-0.08l0.7-1.21c0.04-0.08,0.03-0.17-0.04-0.22L22.1,6.84z M19.5,7.75c-0.69,0-1.25-0.56-1.25-1.25 s0.56-1.25,1.25-1.25s1.25,0.56,1.25,1.25S20.19,7.75,19.5,7.75z" /><path d="M19.92,11.68l-0.5-0.87c-0.03-0.06-0.1-0.08-0.15-0.06l-0.62,0.25c-0.13-0.1-0.27-0.18-0.42-0.24l-0.09-0.66 C18.12,10.04,18.06,10,18,10h-1c-0.06,0-0.11,0.04-0.12,0.11l-0.09,0.66c-0.15,0.06-0.29,0.15-0.42,0.24l-0.62-0.25 c-0.06-0.02-0.12,0-0.15,0.06l-0.5,0.87c-0.03,0.06-0.02,0.12,0.03,0.16l0.53,0.41c-0.01,0.08-0.02,0.16-0.02,0.24 c0,0.08,0.01,0.17,0.02,0.24l-0.53,0.41c-0.05,0.04-0.06,0.11-0.03,0.16l0.5,0.87c0.03,0.06,0.1,0.08,0.15,0.06l0.62-0.25 c0.13,0.1,0.27,0.18,0.42,0.24l0.09,0.66C16.89,14.96,16.94,15,17,15h1c0.06,0,0.12-0.04,0.12-0.11l0.09-0.66 c0.15-0.06,0.29-0.15,0.42-0.24l0.62,0.25c0.06,0.02,0.12,0,0.15-0.06l0.5-0.87c0.03-0.06,0.02-0.12-0.03-0.16l-0.52-0.41 c0.01-0.08,0.02-0.16,0.02-0.24c0-0.08-0.01-0.17-0.02-0.24l0.53-0.41C19.93,11.81,19.94,11.74,19.92,11.68z M17.5,13.33 c-0.46,0-0.83-0.38-0.83-0.83c0-0.46,0.38-0.83,0.83-0.83s0.83,0.38,0.83,0.83C18.33,12.96,17.96,13.33,17.5,13.33z" /><path d="M4.74,9h8.53c0.27,0,0.49-0.22,0.49-0.49V8.49c0-0.27-0.22-0.49-0.49-0.49H13c0-1.48-0.81-2.75-2-3.45V5.5 C11,5.78,10.78,6,10.5,6S10,5.78,10,5.5V4.14C9.68,4.06,9.35,4,9,4S8.32,4.06,8,4.14V5.5C8,5.78,7.78,6,7.5,6S7,5.78,7,5.5V4.55 C5.81,5.25,5,6.52,5,8H4.74C4.47,8,4.25,8.22,4.25,8.49v0.03C4.25,8.78,4.47,9,4.74,9z" /><path d="M9,13c1.86,0,3.41-1.28,3.86-3H5.14C5.59,11.72,7.14,13,9,13z" /></g></g></svg></SvgIcon>}
                                tooltipTitle="Задача на разработчика"
                                tooltipOpen
                                tooltipPlacement="right"
                                onClick={this.handleCardDeveloperAdd}
                            />
                        </SpeedDial>
                    </div>

                    <div className="quick-filter-item">
                        <FormControlLabel
                            control={
                                <Checkbox checked={this.state.isOnlyMy} onChange={this.handleQuickFilterMyChange} value="true" />
                            }
                            label="Мои задачи"
                        />
                    </div>
                    <div className="quick-filter-item">
                        <FormControlLabel
                            control={
                                <Checkbox checked={this.state.isOnlyMyProjects} onChange={this.handleQuickFilterMyProjectChange} value="true" />
                            }
                            label="Мои проекты"
                        />
                    </div>
                    <div className="quick-filter-item">
                        <ProjectSelect key="kanban" name={this.state.filterProjectName} handleSelect={this.handleQuickFilterProjectChange} />
                    </div>
                    <div className="quick-filter-item">
                        <UserSelect label="Ответственный" name={this.state.filterAssigneeName} handleSelect={this.handleQuickFilterAssigneChange} />
                    </div>
                    <div className="quick-filter-item">
                        <PrioritySelectBlock name={this.state.filterPriorityName} handleSelect={this.handleQuickFilterPriorityChange} />
                    </div>
                    <div className="quick-filter-item">
                        <AccountSelect name={this.state.filterAccountName} handleSelect={this.handleQuickFilterAccountChange} />
                    </div>
                    <div className="quick-filter-item">
                        <FormControlLabel
                            control={
                                <Checkbox checked={this.state.isShowAll} onChange={this.handleQuickFilterIsShowAllChange} value="true" />
                            }
                            label="Отображать всё"
                        />
                    </div>
                    <div className="quick-filter-item">
                        <FormControlLabel
                            control={
                                <Checkbox checked={this.state.isPortal} onChange={this.handleQuickFilterIsPortalOnChange} value="true" />
                            }
                            label="Портал"
                        />
                    </div>

                    <div className="quick-filter-item right-menu">
                        <IconButton onClick={this.handleColumnMenuClick} size="large">
                            <MenuIcon />
                        </IconButton>
                        <Popover
                            id="column-menu"
                            open={this.state.isColumnMenuOpen}
                            anchorEl={this.state.menuAnchorEl}
                            onClose={this.handleColumnMenuClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'center',
                                horizontal: 'right',
                            }}
                        >
                            {this.state.columns.map(column => (
                                <div key={column.id}>
                                    <Checkbox checked={column.isShow} onClick={this.handleColumnShowChange(column)} /> {column.name} &nbsp;
                                </div>
                            ))}
                        </Popover>
                    </div>

                </div>
                {this.state.isOnlyMyProjects && <ProjectChipBlock onProjectSelect={this.handleQuickFilterProjectsChange} />}
                
                <div style={{ display: "flex" }}>
                    <DragDropContext onDragEnd={this.handleOnDragEnd}>
                        {this.state.columns.filter(c => !!c.isShow).map((column) => {
                            return (
                                <KanbanColumn
                                    name={column.name}
                                    id={column.id}
                                    works={WorkStore.getWorks.filter((w) => { return (!column.isMultiply && w.statusId === column.id) || (column.isMultiply && column.id.findIndex(i => i.value === w.statusId) > -1) }).sort(this.sort)}
                                    onWorkUpdate={this.handleWorkFlagUpdate}
                                    isCollapseColumn={column.isCollapsable}
                                    isGroupable={column.isGroupable}
                                    isMultiply={column.isMultiply}
                                    key={column.id}
                                    onCardOpen={this.handleCardOpen}
                                    onCtrlCardClick={this.handleCtrlCardClick}
                                />
                            );
                        })}
                    </DragDropContext>
                </div>
                <FilterBottomPanel handleChange={this.handleChange} filterChanged={this.startSearch} startSearch={this.startSearch} />

            </div>
        );
    }
});